import { render, staticRenderFns } from "./DocumentProcess.vue?vue&type=template&id=4af0fa4c&scoped=true"
import script from "./DocumentProcess.vue?vue&type=script&lang=js"
export * from "./DocumentProcess.vue?vue&type=script&lang=js"
import style0 from "./DocumentProcess.vue?vue&type=style&index=0&id=4af0fa4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af0fa4c",
  null
  
)

export default component.exports